import { ModuleFE_Pathway } from './_entity/pathway/index.js';
import { ModuleFE_PathwayState } from './_entity/pathway-state/index.js';
import { ModuleFE_PathwayTransition } from './_entity/pathway-transition/index.js';
import { ModulePackFE_ActionDB } from './_entity/action/index.js';
import { ModulePackFE_OrderGroupDB } from './_entity.js';
export const ModulePackFE_Pathway = [
    ...ModulePackFE_ActionDB,
    ...ModulePackFE_OrderGroupDB,
    ModuleFE_Pathway,
    ModuleFE_PathwayState,
    ModuleFE_PathwayTransition,
];
//# sourceMappingURL=module-pack.js.map